// import { CouponTypes } from "../action_types/category_types";
import { CouponTypes } from "../action_types/coupon_types";

const initialState = {
    coupons: []
};

export default function CouponReducer(state = initialState, action = null) {
  if (!state) {
    state = initialState;
  }
  switch (action.type) {
    case CouponTypes.GET_COUPONS_SUCCESS: {
      return {
        ...state,
        ...action.data
      };
    }
    default:
      return state;
  }
}
